import React from 'react';
import { Box, Container, Typography, Button, Card, CardActions, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Relatorios: React.FC = () => {
  const navigate = useNavigate();

  const relatorios = [
    { label: 'Estoque', path: '/Relatorios/estoque' },
    { label: 'Relatório de saídas - Filtro por praça e data prevista de retorno', path: '/Relatorios/saida-por-praca-e-data-retorno' },
    { label: 'Romaneio - Diferença entre quantidade de produtos no romaneio e deixados em notas de saídas', path: '/Relatorios/diferenca-romaneio-saidas' },
    { label: 'Romaneio - Conferência', path: '/Relatorios/itens-nao-vendidos-por-romaneio' },
    { label: 'Romaneio - Conferência Saída', path: '/Relatorios/itens-nao-ficaram-em-saida' },
    { label: 'Vendas - vendas por período e referência', path: '/Relatorios/Venda-por-periodo' },
    { label: 'Vendas - vendas por período (todos os itens agrupados por linha e detalhado referência)', path: '/Relatorios/Venda-por-periodo-linha' },
    { label: 'Cobrança - Por Praça', path: '/Relatorios/Cobranca-por-praca' },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Relatórios
      </Typography>

      <Card>
        {relatorios.map((relatorio, index) => (
          <React.Fragment key={relatorio.path}>
            <CardActions>
              <Button fullWidth onClick={() => navigate(relatorio.path)} sx={{ justifyContent: 'flex-start' }}>
                {relatorio.label}
              </Button>
            </CardActions>
            {index < relatorios.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Card>
    </Container>
  );
};

export default Relatorios;
